<template>
    <div class="w-full p-4 rounded-lg bg-nomad-800 hover:bg-nomad-700 hover:shadow-md transition-all duration-300">
        <div class="space-y-2">
            <!-- Date -->
            <p class="text-nomad-400 text-xs font-light">{{ episode.pubDate }}</p>

            <!-- Episode Title -->
            <h3 class="text-lg font-semibold text-white">
                <Link :href="'/episode/' + episode.id" class="hover:text-nomad-accent transition-colors">
                {{ episode.title }}
                </Link>
            </h3>

            <!-- Episode Excerpt -->
            <p class="text-nomad-300 text-sm font-light line-clamp-2">{{ episode.excerpt }}</p>

            <!-- Actions -->
            <div class="flex items-center gap-3 pt-2">
                <button @click="prepareCurrent({ id: episode.id, type: 'EPISODE' })"
                    class="flex items-center gap-2 px-4 py-2 rounded-lg bg-nomad-accent hover:bg-nomad-accent/80 text-nomad-900 font-semibold transition-all text-sm"
                    aria-label="Play Episode">
                    <span class="icon-play"></span>
                    <span>Play</span>
                </button>
                <span v-if="episode.source && episode.source[0]" class="text-nomad-400 text-xs font-light">
                    {{ episode.source[0].length }}
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import { Link } from "@inertiajs/vue3";
import { mapState, mapActions } from "vuex";
export default {
    name: "EpisodeCard",
    props: {
        episode: Object,
    },
    components: {
        Link,
    },
    methods: {
        ...mapActions("current", ["prepareCurrent"]),
    },
};
</script>
